import styled from '@emotion/styled'
import * as v from '../../../variables/styles'

export const TableContainer = styled.div`

`

export const ViewDataPatternContent = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin: 10px 0px;
  align-items: flex-end;

  .patternButton {
    background: #FFF;
    border: solid 1px #FFF;
    padding: 0px !important;
    width: 25px;
    height: 25px;
  }

  .patternButton:hover {
    background: #FFF;
    color: ${v.ezMainColor};
  }

  .patternButton.active {
    color: #FFF;
    background: ${v.ezMainColor};
    border: solid 1px ${v.ezMainColor};
  }

  .patternButton.active:hover {
    color: #FFF;
    background: ${v.ezMainColor};
    border: solid 1px ${v.ezMainColor};
  }
`

export const TableContent = styled.div`
  .ReactTable {
    border: none;
    font-family: 'IBM Plex Sans Thai';
    font-size: 1rem;
  }

  .ReactTable .rt-table {
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 5px;
  }

  .ReactTable .rt-thead.-header {
    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.15);
    background: #FFF;
    font-size: 12px;
    font-weight: bold;
    color: #505050;
    border-bottom: solid 1.5px rgba(0, 0, 0, 0.1);
  }

  .ReactTable .rt-tbody .rt-tr-group {
    border: none;
  }

  .ReactTable .rt-tbody .rt-tr-group:nth-child(odd) {
    background: #F0F0F0;
  }

  .ReactTable .rt-tbody .rt-tr-group:nth-child(even) {
    background: #FAFAFA;
  }

  .ReactTable .rt-tbody .rt-td {
    display: flex;
    justify-content: center;
  }

  .ReactTable .rt-td {
    padding: 10px 5px;
  }

  .rt-tr-group {
  }
`

export const ListRecordsContent = styled.div`
  .ReactTable {
    border: none !important;
  }

  .ReactTable .rt-thead.-header {
    display: none !important;
  }

  .rt-tr-group {
    border: none !important;
  }

  .ReactTable .rt-th, .ReactTable .rt-td {
    padding: 0px 0px 10px 0px;
  }
`